import { Video } from '@/types'
import { globalState } from '@codeleap/store'

const videoCache = globalState<Record<string, string>>({})

function get(id: string | number): string | undefined {
  return videoCache.get()[id]
}

function set(id: string | number, data: Partial<string>) {
  videoCache.set({ [id]: data })
}

function use(id: number | string, data: Video): string {
  const cached = videoCache.use(s => s[id])
  if (cached) return cached
  return data.url
}

export const VideoCache = { get, set, use, videoCache }
